import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { api, versao } from '../../config';
import { getHeaders, getToken } from '../../actions/localStorage';
import { loteAtribuir, loteNotificarWhatsApp, loteSaiuParaEntrega } from '../../actions/entregas';
import {
	clearAssignDeliveryBatchDraft,
	clearAssignDeliveryReturnPath,
	extractEntregaIdFromQrText,
	loadAssignDeliveryBatchDraft,
	saveAssignDeliveryBatchDraft,
	setAssignDeliveryReturnPath,
} from '../../utils/assignDeliveryHelpers';
import { openWhatsAppUrl } from '../../utils/openWhatsAppUrl';
import { scrollQrReaderIntoView, startAssignDeliveryHtml5Reader } from '../../utils/assignDeliveryScanner';
import Modal from '../../components/Modal/Simple';

const READER_ID = 'assign-delivery-qr-reader';

/** Outras abas / tela Entregas podem ouvir e refazer GET admin/resumo (cards do dashboard). */
function notifyEntregasResumoChanged(){
	window.dispatchEvent(new CustomEvent('entregas-resumo-refresh'));
	try{
		localStorage.setItem('entregas-resumo-bump', String(Date.now()));
	}catch(_e){ /* noop */ }
}

class AssignDelivery extends Component {

	state = {
		loading: true,
		error: null,
		needsLogin: false,
		lojaId: null,
		entregadores: [],
		canAssign: false,
		stops: [],
		entregadorId: '',
		confirming: false,
		scanning: false,
		pasteValue: '',
		done: false,
		loteCodigo: '',
		whatsappNotifyUrl: null,
		whatsappAskOpen: false,
		userNotice: null,
		temLote: false,
		loteId: null,
		lockedLoteCodigo: null,
		notifyingWhatsApp: false,
	}

	showUserNotice = (text) => {
		this.setState({ userNotice: text });
	}

	clearUserNotice = () => {
		this.setState({ userNotice: null });
	}

	componentDidMount(){
		this.carregar();
		this._onVisibilityPersist = () => {
			if(document.hidden) this.persistAssignDeliveryBatchDraft();
		};
		this._onPageHidePersist = () => {
			this.persistAssignDeliveryBatchDraft();
		};
		document.addEventListener('visibilitychange', this._onVisibilityPersist);
		window.addEventListener('pagehide', this._onPageHidePersist);
	}

	componentDidUpdate(prevProps, prevState){
		const { loading, error, done, lojaId, stops, entregadorId, canAssign, scanning } = this.state;
		if(done && !prevState.done){
			clearAssignDeliveryBatchDraft();
		}
		if(loading || error || done || !lojaId) return;
		if(stops !== prevState.stops || entregadorId !== prevState.entregadorId || canAssign !== prevState.canAssign){
			this.persistAssignDeliveryBatchDraft();
		}
		if(scanning && !prevState.scanning){
			scrollQrReaderIntoView(READER_ID);
		}
	}

	componentWillUnmount(){
		this.persistAssignDeliveryBatchDraft();
		document.removeEventListener('visibilitychange', this._onVisibilityPersist);
		window.removeEventListener('pagehide', this._onPageHidePersist);
		this.pararScanner();
	}

	persistAssignDeliveryBatchDraft = () => {
		const entregaId = this.props.match.params.entregaId;
		const { stops, entregadorId, canAssign, lojaId, loading, error, done } = this.state;
		if(done || loading || error || !lojaId || !entregaId || !stops.length) return;
		saveAssignDeliveryBatchDraft({
			routeEntregaId: entregaId,
			lojaId,
			stops,
			entregadorId,
			canAssign,
		});
	}

	pararScanner = () => {
		if(this._html5Qr){
			this._html5Qr.stop().catch(() => {}).finally(() => {
				this._html5Qr = null;
			});
		}
	}

	carregar = () => {
		const entregaId = this.props.match.params.entregaId;
		if(!getToken()){
			setAssignDeliveryReturnPath(entregaId);
			this.setState({
				loading: false,
				error: 'Faça login no painel neste dispositivo para atribuir o lote.',
				needsLogin: true,
			});
			return;
		}
		const { usuario } = this.props;
		const carregarEntrega = (loja) => {
			axios.get(`${api}/${versao}/api/entregas/admin/${entregaId}/atribuicao-operador?loja=${loja}`, getHeaders())
				.then((res) => {
					const d = res.data;
					const sid = d.entrega && d.entrega.simpleId ? d.entrega.simpleId : '—';
					const eid = d.entrega && d.entrega._id ? d.entrega._id : entregaId;
					const clienteNome = d.entrega && d.entrega.clienteNome ? d.entrega.clienteNome : '';
					clearAssignDeliveryReturnPath();
					const draft = loadAssignDeliveryBatchDraft(entregaId);
					let mergedStops = [{ entregaId: eid, simpleId: sid, clienteNome }];
					let mergedEntregadorId = '';
					const mergedCanAssign = !!d.canAssign;
					let restoredDraft = false;
					if(
						draft
						&& String(draft.lojaId) === String(d.lojaId)
						&& draft.stops.some((s) => s.entregaId === eid)
					){
						if(mergedCanAssign){
							mergedStops = draft.stops;
							mergedEntregadorId = draft.entregadorId || '';
							restoredDraft = draft.stops.length > 1;
						}else{
							clearAssignDeliveryBatchDraft();
						}
					}
					this.setState({
						loading: false,
						error: null,
						needsLogin: false,
						lojaId: d.lojaId,
						entregadores: d.entregadores || [],
						canAssign: mergedCanAssign,
						stops: mergedStops,
						entregadorId: mergedEntregadorId,
						temLote: !!d.temLote,
						loteId: d.loteId || null,
						lockedLoteCodigo: d.loteCodigo || null,
					}, () => {
						if(restoredDraft) this.revalidarStops();
					});
				})
				.catch((err) => {
					const status = err.response && err.response.status;
					if(status === 401){
						setAssignDeliveryReturnPath(entregaId);
						this.setState({ loading: false, error: 'Faça login no painel neste dispositivo.', needsLogin: true });
						return;
					}
					const msg = err.response && err.response.data && err.response.data.error
						? err.response.data.error
						: 'Não foi possível carregar.';
					this.setState({ loading: false, error: msg, needsLogin: false });
				});
		};
		if(usuario && usuario.loja){
			carregarEntrega(usuario.loja);
			return;
		}
		axios.get(`${api}/${versao}/api/usuarios/`, getHeaders())
			.then((r) => {
				const loja = r.data && r.data.usuario && r.data.usuario.loja;
				if(!loja){
					setAssignDeliveryReturnPath(entregaId);
					this.setState({ loading: false, error: 'Sessão inválida. Faça login novamente.', needsLogin: true });
					return;
				}
				carregarEntrega(loja);
			})
			.catch((err) => {
				const status = err.response && err.response.status;
				if(status === 401){
					setAssignDeliveryReturnPath(entregaId);
					this.setState({ loading: false, error: 'Faça login no painel neste dispositivo.', needsLogin: true });
					return;
				}
				this.setState({ loading: false, error: 'Não foi possível validar a sessão.', needsLogin: false });
			});
	}

	revalidarStops = async () => {
		const { stops, lojaId, loading, done } = this.state;
		if(loading || done || !lojaId || stops.length <= 1) return;
		const validated = [];
		for(let i = 0; i < stops.length; i++){
			const stop = stops[i];
			try {
				const res = await axios.get(
					`${api}/${versao}/api/entregas/admin/${stop.entregaId}/atribuicao-operador?loja=${lojaId}`,
					getHeaders()
				);
				if(!res.data.canAssign) continue;
				const entrega = res.data.entrega || {};
				validated.push({
					entregaId: stop.entregaId,
					simpleId: entrega.simpleId || stop.simpleId,
					clienteNome: entrega.clienteNome || stop.clienteNome,
				});
			}catch(_err){
				/* entrega indisponível — omitir da lista */
			}
		}
		if(!validated.length){
			clearAssignDeliveryBatchDraft();
			this.carregar();
			return;
		}
		if(validated.length !== stops.length){
			this.setState({ stops: validated }, () => {
				this.showUserNotice('Algumas entregas foram removidas da lista porque já possuem lote ou não podem mais ser atribuídas.');
			});
		}
	}

	adicionarEntrega = async (raw) => {
		const id = extractEntregaIdFromQrText(raw);
		if(!id){
			this.showUserNotice('Código inválido. Use o QR da impressão ou cole a URL completa.');
			return;
		}
		const { stops, lojaId, canAssign: batchCanAssign } = this.state;
		if(stops.some((s) => s.entregaId === id)){
			this.showUserNotice('Esta entrega já está na lista.');
			return;
		}
		if(!lojaId){
			this.showUserNotice('Sessão inválida.');
			return;
		}
		try {
			const res = await axios.get(`${api}/${versao}/api/entregas/admin/${id}/atribuicao-operador?loja=${lojaId}`, getHeaders());
			if(res.data.lojaId !== lojaId){
				this.showUserNotice('Esta entrega pertence a outra loja.');
				return;
			}
			const simpleId = res.data.entrega && res.data.entrega.simpleId ? res.data.entrega.simpleId : '—';
			const clienteNome = res.data.entrega && res.data.entrega.clienteNome ? res.data.entrega.clienteNome : '';
			if(!res.data.canAssign){
				this.showUserNotice('Esta entrega não pode receber lote por aqui (já possui lote ou situação inválida).');
				return;
			}
			const list = res.data.entregadores || [];
			if(!batchCanAssign){
				this.setState({
					canAssign: true,
					entregadores: list.length ? list : this.state.entregadores,
					entregadorId: '',
					stops: [{ entregaId: id, simpleId, clienteNome }],
				});
				return;
			}
			this.setState((prev) => ({
				stops: [...prev.stops, { entregaId: id, simpleId, clienteNome }],
			}));
		}catch(err){
			const status = err.response && err.response.status;
			if(status === 401){
				this.showUserNotice('Faça login no painel neste dispositivo.');
				return;
			}
			const msg = err.response && err.response.data && err.response.data.error
				? err.response.data.error
				: 'Não foi possível validar o código.';
			this.showUserNotice(msg);
		}
	}

	onPasteAdd = () => {
		this.adicionarEntrega(this.state.pasteValue);
		this.setState({ pasteValue: '' });
	}

	iniciarScanner = () => {
		if(this.state.scanning) return;
		this.setState({ scanning: true }, () => {
			window.setTimeout(async () => {
				if(!document.getElementById(READER_ID)){
					this.setState({ scanning: false });
					return;
				}
				try{
					const { html5 } = await startAssignDeliveryHtml5Reader(
						READER_ID,
						async (decodedText, html5) => {
							try {
								await html5.stop();
							}catch(_e){ /* noop */ }
							this._html5Qr = null;
							this.setState({ scanning: false });
							await this.adicionarEntrega(decodedText);
						},
						() => {}
					);
					this._html5Qr = html5;
					scrollQrReaderIntoView(READER_ID);
				}catch(_err){
					this._html5Qr = null;
					this.setState({ scanning: false });
					this.showUserNotice('Não foi possível usar a câmera. Use colar URL ou digite o código.');
				}
			}, 260);
		});
	}

	cancelarScanner = () => {
		this.pararScanner();
		this.setState({ scanning: false });
	}

	removerStop = (idx) => {
		if(this.state.stops.length <= 1){
			this.showUserNotice('Mantenha ao menos a entrega inicial.');
			return;
		}
		this.setState((prev) => ({
			stops: prev.stops.filter((_, i) => i !== idx),
		}));
	}

	dismissWhatsAppAsk = () => {
		this.setState({ whatsappAskOpen: false });
	}

	acceptWhatsAppAsk = () => {
		const url = this.state.whatsappNotifyUrl;
		if(url) openWhatsAppUrl(url);
		this.setState({ whatsappAskOpen: false, whatsappNotifyUrl: null });
	}

	openWhatsAppFromSucesso = () => {
		const url = this.state.whatsappNotifyUrl;
		if(url) openWhatsAppUrl(url);
		this.setState({ whatsappNotifyUrl: null });
	}

	notificarWhatsAppNovamente = () => {
		const { lojaId, loteId, stops, notifyingWhatsApp } = this.state;
		if(notifyingWhatsApp || !lojaId) return;
		const body = loteId
			? { loteId }
			: { entregaIds: stops.map((s) => s.entregaId) };
		this.setState({ notifyingWhatsApp: true, userNotice: null });
		this.props.loteNotificarWhatsApp(lojaId, body)
			.then((data) => {
				this.setState({ notifyingWhatsApp: false });
				if(!data || (data.status && data.message)){
					this.showUserNotice(data && data.message ? data.message : 'Não foi possível gerar o WhatsApp.');
					return;
				}
				if(data.error){
					this.showUserNotice(typeof data.error === 'string' ? data.error : 'Não foi possível gerar o WhatsApp.');
					return;
				}
				if(data.whatsappUrl){
					openWhatsAppUrl(data.whatsappUrl);
				}
			})
			.catch(() => {
				this.setState({ notifyingWhatsApp: false });
				this.showUserNotice('Erro ao preparar mensagem do WhatsApp.');
			});
	}

	confirmar = () => {
		const { entregadorId, stops, canAssign, lojaId } = this.state;
		const { loteAtribuir, loteSaiuParaEntrega } = this.props;
		if(!canAssign){
			this.showUserNotice('Esta entrega não pode receber lote por esta página.');
			return;
		}
		if(!entregadorId){
			this.showUserNotice('Selecione o motorista.');
			return;
		}
		if(!lojaId){
			this.showUserNotice('Sessão inválida.');
			return;
		}
		const entregaIds = stops.map((s) => s.entregaId);
		this.setState({ confirming: true, userNotice: null });
		loteAtribuir(lojaId, entregaIds, entregadorId, { exigirSemLoteAtual: true })
			.then((res) => {
				if(!res || (res.status && res.message)){
					this.setState({
						confirming: false,
						userNotice: res && res.message ? res.message : null,
					});
					return;
				}
				if(res.error){
					this.setState({
						confirming: false,
						userNotice: typeof res.error === 'string' ? res.error : 'Erro ao processar.',
					}, () => {
						if(typeof res.error === 'string' && res.error.includes('já possui lote')){
							this.revalidarStops();
						}
					});
					return;
				}
				clearAssignDeliveryBatchDraft();
				return loteSaiuParaEntrega(lojaId, entregaIds).then((resStatus) => {
					if(!resStatus || (resStatus.status && resStatus.message)){
						this.setState({
							confirming: false,
							userNotice: resStatus && resStatus.message ? resStatus.message : null,
						});
						return;
					}
					if(resStatus.error){
						this.setState({
							confirming: false,
							userNotice: typeof resStatus.error === 'string'
								? resStatus.error
								: 'Não foi possível marcar como saiu para entrega. O lote foi criado; atualize o status na tela Entregas.',
						});
						return;
					}
					const wurl = res.whatsappUrl;
					const codigo = res.lote && res.lote.codigo ? res.lote.codigo : '';
					this.setState({
						confirming: false,
						done: true,
						loteCodigo: codigo,
						whatsappNotifyUrl: wurl || null,
						whatsappAskOpen: !!wurl,
						userNotice: null,
					});
					notifyEntregasResumoChanged();
				});
			})
			.catch(() => {
				this.setState({ confirming: false, userNotice: 'Erro ao atribuir lote.' });
			});
	}

	render(){
		const {
			loading, error, needsLogin, entregadores, canAssign, stops, entregadorId, confirming, scanning, pasteValue, done, loteCodigo,
			whatsappNotifyUrl, whatsappAskOpen, userNotice, temLote, lockedLoteCodigo, notifyingWhatsApp,
		} = this.state;

		const userNoticeBanner = userNotice ? (
			<div className="assignDelivery-aviso assignDelivery-aviso--notice" role="alert">
				<p className="assignDelivery-aviso-msg">{userNotice}</p>
				<button type="button" className="assignDelivery-btnSec assignDelivery-aviso-ok" onClick={this.clearUserNotice}>
					OK
				</button>
			</div>
		) : null;

		if(done){
			const sucessoSemWhatsAppMsg = !whatsappNotifyUrl && (
				<p className="assignDelivery-msg">Lote atribuído e entregas marcadas como saiu para entrega.</p>
			);
			return (
				<div className="assignDelivery">
					{ whatsappAskOpen && whatsappNotifyUrl && (
						<Modal
							h1={'Lote atribuído e status "Saiu para entrega". Deseja abrir o WhatsApp para notificar o entregador?'}
							cancelFunction={this.dismissWhatsAppAsk}
							confirmFunction={this.acceptWhatsAppAsk}
						/>
					) }
					<div className="assignDelivery-card">
						<h1 className="assignDelivery-titulo">Lote criado</h1>
						{ userNoticeBanner }
						{ loteCodigo && <p className="assignDelivery-msg">Código: <strong>{loteCodigo}</strong></p> }
						{ sucessoSemWhatsAppMsg }
						{ !whatsappAskOpen && whatsappNotifyUrl && (
							<button type="button" className="assignDelivery-btnPri" onClick={this.openWhatsAppFromSucesso}>
								Abrir WhatsApp para notificar o entregador
							</button>
						) }
						<p className="assignDelivery-msg">O que deseja fazer agora?</p>
						<div className="assignDelivery-sucessoAcoes">
							<Link
								to={{ pathname: '/assign-delivery', state: { openScanner: true } }}
								className="assignDelivery-btnPri assignDelivery-loginLink"
							>
								Escanear outra etiqueta
							</Link>
							<Link to="/assign-delivery" className="assignDelivery-btnOutline assignDelivery-loginLink">
								Tela inicial do leitor
							</Link>
						</div>
					</div>
				</div>
			);
		}

		if(loading){
			return (
				<div className="assignDelivery">
					<p className="assignDelivery-msg">Carregando…</p>
				</div>
			);
		}

		if(error){
			return (
				<div className="assignDelivery">
					<div className="assignDelivery-card assignDelivery-card--erro">
						<p className="assignDelivery-erro">{error}</p>
						{ needsLogin && (
							<Link to="/login" className="assignDelivery-btnOutline assignDelivery-loginLink">
								Ir para o login
							</Link>
						) }
					</div>
				</div>
			);
		}

		const scanReader = scanning ? (
			<>
				<div id={READER_ID} className="assignDelivery-reader" />
				<button type="button" className="assignDelivery-btnSec" onClick={this.cancelarScanner}>
					Cancelar câmera
				</button>
			</>
		) : null;

		const scanPasteRow = (
			<div className="assignDelivery-pasteRow">
				<input
					type="text"
					className="assignDelivery-input"
					placeholder="Ou cole a URL ou o ID da entrega (24 caracteres)"
					value={pasteValue}
					onChange={(ev) => this.setState({ pasteValue: ev.target.value })}
				/>
				<button type="button" className="assignDelivery-btnSec" onClick={this.onPasteAdd}>
					Usar código colado
				</button>
			</div>
		);

		return (
			<div className="assignDelivery">
				<div className="assignDelivery-card">
					<h1 className="assignDelivery-titulo">Atribuir lote</h1>
					{ userNoticeBanner }

					{ !canAssign ? (
						<>
							<div className="assignDelivery-aviso assignDelivery-aviso--danger" role="alert">
								<p className="assignDelivery-aviso-msg">
									O código desta etiqueta abriu um pedido que <strong>já tem lote</strong> ou não pode ser tratado nesta tela.
									Para atribuir lote, use a câmera ou cole abaixo o código de <strong>outra entrega</strong> que ainda aceite lote.
								</p>
							</div>
							{ temLote && (
								<div className="assignDelivery-bloco assignDelivery-bloco--whatsapp">
									{ lockedLoteCodigo && (
										<p className="assignDelivery-msg assignDelivery-msg--lote">Lote atual: <strong>{lockedLoteCodigo}</strong></p>
									) }
									<button
										type="button"
										className="assignDelivery-btnWhatsApp"
										onClick={this.notificarWhatsAppNovamente}
										disabled={notifyingWhatsApp}
									>
										{ notifyingWhatsApp ? 'Preparando…' : 'Abrir WhatsApp para notificar o entregador novamente' }
									</button>
								</div>
							) }

							<div className="assignDelivery-bloco assignDelivery-bloco--destaque">
								<span className="assignDelivery-label">Passo seguinte</span>
								{ scanning ? scanReader : (
									<button
										type="button"
										className="assignDelivery-btnPri assignDelivery-btnScan"
										onClick={this.iniciarScanner}
									>
										Abrir câmera e escanear QR
										<span className="assignDelivery-btnScan-sub">Aponte para a etiqueta da entrega correta</span>
									</button>
								) }
								{ scanPasteRow }
							</div>

							<div className="assignDelivery-contextoLido" aria-live="polite">
								<div className="assignDelivery-contextoLido-hd">Somente referência — etiqueta que você abriu</div>
								{ stops.map((s) => (
									<div key={s.entregaId} className="assignDelivery-contextoLido-corpo">
										Pedido #{s.simpleId}
										{ s.clienteNome ? <> — <strong>{s.clienteNome}</strong></> : null }
									</div>
								)) }
								<p className="assignDelivery-contextoLido-rodape">
									Não é possível escolher motorista para este pedido aqui. Se precisar desatribuir o lote, use o painel administrativo.
								</p>
							</div>
						</>
					) : (
						<>
							<p className="assignDelivery-lead">
								Selecione o motorista e confira os pedidos abaixo. Em seguida, <strong>escaneie outra etiqueta</strong> para incluir mais entregas ou <strong>finalize</strong> para criar o lote.
							</p>

							<div className="assignDelivery-bloco">
								<label className="assignDelivery-label" htmlFor="assign-motorista">Motorista</label>
								<select
									id="assign-motorista"
									className="assignDelivery-select"
									value={entregadorId}
									onChange={(ev) => this.setState({ entregadorId: ev.target.value })}
									disabled={confirming}
								>
									<option value="">— Selecione —</option>
									{ entregadores.map((e) => (
										<option key={e.id} value={e.id}>{e.nome}</option>
									)) }
								</select>
							</div>

							<div className="assignDelivery-bloco">
								<span className="assignDelivery-label">Entregas neste lote ({stops.length})</span>
								<div className={scanning || stops.length > 2 ? 'assignDelivery-stopsWrap assignDelivery-stopsWrap--compact' : 'assignDelivery-stopsWrap'}>
									<ul className="assignDelivery-stops">
										{ stops.map((s, idx) => (
											<li key={s.entregaId}>
												<span>
													Pedido #{s.simpleId}
													{ s.clienteNome ? (
														<> — <strong>{s.clienteNome}</strong></>
													) : null }
												</span>
												{ stops.length > 1 && (
													<button type="button" className="assignDelivery-btnSec" onClick={() => this.removerStop(idx)}>
														Remover
													</button>
												) }
											</li>
										)) }
									</ul>
								</div>
							</div>

							<div className="assignDelivery-bloco assignDelivery-bloco--destaque assignDelivery-bloco--proximoPasso">
								<span className="assignDelivery-label">Próximo passo</span>
								<p className="assignDelivery-hint assignDelivery-hint--proximoPasso">
									Ou inclua mais um pedido pela câmera, ou encerre e gere o lote com o motorista escolhido.
								</p>

								<div className="assignDelivery-acoesLinha">
									<span className="assignDelivery-acoesLinha-ttl">Incluir outra entrega</span>
									{ scanning ? scanReader : (
										<button
											type="button"
											className="assignDelivery-btnPri assignDelivery-btnScan"
											onClick={this.iniciarScanner}
										>
											Abrir câmera e escanear QR
											<span className="assignDelivery-btnScan-sub">Outra etiqueta no mesmo lote</span>
										</button>
									) }
									{ scanPasteRow }
								</div>

								<div className="assignDelivery-acoesOu" role="presentation">ou</div>

								<div className="assignDelivery-acoesLinha">
									<span className="assignDelivery-acoesLinha-ttl">Encerrar</span>
									<button
										type="button"
										className="assignDelivery-btnPri assignDelivery-btnPri--finalizar"
										disabled={confirming || !entregadorId}
										onClick={this.confirmar}
									>
										{ confirming ? 'Salvando…' : 'Finalizar lote' }
										<span className="assignDelivery-btnScan-sub assignDelivery-btnPri-sub">Cria o lote, marca como saiu para entrega e notifica o motorista</span>
									</button>
									{ !entregadorId && !confirming && (
										<p className="assignDelivery-hint assignDelivery-hint--avisoMotorista">Selecione o motorista acima para finalizar.</p>
									) }
								</div>
							</div>
						</>
					) }
				</div>
			</div>
		);
	}
}

function mapStateToProps(state){
	return { usuario: state.auth && state.auth.usuario };
}

function mapDispatchToProps(dispatch){
	return bindActionCreators({ loteAtribuir, loteNotificarWhatsApp, loteSaiuParaEntrega }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignDelivery);
